/* ========================================================================
   On document ready do stuff
 ========================================================================== */

util.onDocumentReady(function () {
  // Set frontend version
  util.frontEndVersion = document.getElementById('body').dataset.version;

  // Set debug mode
  util.debugMode = document.getElementById('body').dataset.debugMode === 'true';

  // Enable transitions
  document.documentElement.classList.remove('is-loading');

  // Pristine config
  app.pristineConfig = {
    // class of the parent element where the error/success class is added
    classTo: 'form__group',
    errorClass: 'has-error',
    successClass: 'has-success',
    // class of the parent element where error text element is appended
    errorTextParent: 'form__group',
    // type of element to create for the error text
    errorTextTag: 'div',
    // class of the error text element
    errorTextClass: 'form__validation',
    locale: 'nl',
  };

  // Enable SVG in IE11
  // svg4everybody();

  app.general.initAppHeight();
  // app.general.initAnchorLinks();
  app.navigation.init();
  // app.navigation.initSearchBox();
  app.general.initEmailLinks();
  // app.general.initLax();
  app.cookiePopup.init();
  app.dataLayer.init();

  const min = util.debugMode === false ? '.min' : '';

  if (document.querySelectorAll('[data-toast-message]').length > 0) {
    // show toast messages (with delay)
    const toastMessages = document.querySelectorAll('[data-toast-message]');
    toastMessages.forEach((message, index) => {
      window.setTimeout(() => {
        Toast(message.innerHTML, message.dataset.toastType.toLowerCase(), message.dataset.toastTimeout ?? 7500);
      }, index * 1000);
    });
  }

  if (document.querySelectorAll('[data-accordion-list]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules.accordion' + min + '.js'), () => {
      app.accordion.init();
    });
  }

  if (
    document.querySelectorAll('[data-carousel]').length > 0 ||
    document.querySelectorAll('[data-image-carousel]').length > 0
  ) {
    ljs.load(
      util.getVersionedUrl('/scripts/dist/embla' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/modules.carousel' + min + '.js'),
      () => {
        app.carousel.init();
      }
    );
  }

  if (document.querySelectorAll('[data-video]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules.videos' + min + '.js'), () => {
      app.videos.init();
    });
  }

  if (document.querySelectorAll('[data-video-lightbox]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/videoLightbox' + min + '.js'), () => {
      const videos = document.querySelectorAll('[data-video-lightbox]');
      const lightbox = VideoLightbox(videos);

      window.addEventListener(
        'cookieconsent_update',
        (event) => {
          if (lightbox.hasMarketingConsent()) {
            lightbox.removeConsentWarning();
          }
        },
        false
      );
    });
  }

  if (document.querySelectorAll('[data-news-listing]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules.newsListing' + min + '.js'), () => {
      app.newsListing.init();
    });
  }

  if (document.querySelectorAll('[data-job-listing]').length > 0) {
    ljs.load(
      util.getVersionedUrl('/scripts/dist/isolde' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/modules.jobListing' + min + '.js'),
      () => {
        app.jobListing.init();
      }
    );
  }

  if (document.querySelector('.searchResults')) {
    if (document.location.href.indexOf('?') > -1) {
      setTimeout(() => {
        document.querySelector('#zoekresultaten').scrollIntoView({
          behavior: 'smooth',
        });
      }, 500);
    }
  }

  // ljs.load(
  //   util.getVersionedUrl('/scripts/dist/aspnet-validation' + min + '.js'),
  //   util.getVersionedUrl('/scripts/dist/forms.validation' + min + '.js'),
  //   util.getVersionedUrl('/scripts/dist/forms.newsletter' + min + '.js'),
  //   () => {
  //     app.newsletterForm.init();

  //     if (document.querySelectorAll('[data-jobalert-form]').length > 0) {
  //       ljs.load(
  //         util.getVersionedUrl('/scripts/dist/forms.jobalert' + min + '.js'),
  //         () => {
  //           app.jobAlertForm.init();
  //         }
  //       );
  //     }
  //   }
  // );

  if (document.querySelectorAll('[data-jobalert-form]').length > 0) {
    ljs.load(
      util.getVersionedUrl('/scripts/dist/aspnet-validation' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/forms.validation' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/forms.jobalert' + min + '.js'),
      () => {
        app.jobAlertForm.init();
      }
    );
  }

  if (document.querySelectorAll('[data-lax]').length > 0) {
    ljs.load(
      util.getVersionedUrl('/scripts/dist/lax' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/modules.lax' + min + '.js'),
      () => {
        app.lax.init();
      }
    );
  }
});
